<template>
  <v-container fluid class="grey700 px-8 py-6 text-center">
    <v-img src="@/assets/img/trader.png" class="mx-auto mb-3" max-width="200" />

    <h5 class="text-h6 text-uppercase font-weight-bold blue400--text mb-2">
      Roleplayer detected!
    </h5>
    <p class="text-body-1 mb-6">
      Your name was changed because it contained banned words.
    </p>

    <v-btn
      depressed block large tile
      color="blue800 blue300--text"
      class="font-weight-semibold"
      :ripple="false"
      @click="$modal.open('account', { maxWidth: 1000 }, { tab: 'settings' }); close()"
    >
      Change name
    </v-btn>
  </v-container>
</template>

<script>
export default {
  props: {
    close: { type: [Function, Object], required: true },
  },
}
</script>
